import { render, staticRenderFns } from "./psnpayrollEdit.vue?vue&type=template&id=13ca195e"
import script from "./psnpayrollEdit.vue?vue&type=script&lang=js"
export * from "./psnpayrollEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports